
import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    Menu,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableSortLabel,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    TextField,
    Button,
    Container,
    Paper
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses';
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PersonIcon from "@mui/icons-material/Person";
import {useTheme} from '@mui/material/styles';
import {ListViewModel,
        ListViewColumnModel,
        EmailPreviewModel,
        RecordModel} from '../../models/models';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {SearchFieldComponent} from "../../components/searchField/SearchField";
import {useSnackbar} from "notistack";
import { formatDate, formatDatetime } from "../../utils/dateFunctions";
import {Link, useParams} from 'react-router-dom';
import {getAppName, getObjectName } from "../../utils/helperRouter";

export const EmailPreviewComponent: React.FC<{
  emailPreviews: EmailPreviewModel[]
}> = ({
  emailPreviews
}) => {

  useEffect(() => {
    if(emailPreviews.length > 0) setCurrentPreview(emailPreviews[0])
  }, [emailPreviews])


  const styles = ContainerClasses();

  const [currentPreview, setCurrentPreview] = useState<EmailPreviewModel | null>(null);

  const recipientListElement = () => {

    const recipientButton = (thisPreview: EmailPreviewModel) => {
      return (
          <Button
            key={thisPreview.recipient.email}
            fullWidth
            variant="text"
            disabled={false/*renderedTemplate?.recipient.email === thisTemplate.recipient.email*/}
            onClick={() => {
              setCurrentPreview(thisPreview);
             }
            }
            sx={{
              justifyContent: 'flex-start',
              mb: 1,
              borderRadius: 0,
              backgroundColor: currentPreview?.recipient.email === thisPreview.recipient.email ? 'primary.main' : 'transparent',
              color: currentPreview?.recipient.email === thisPreview.recipient.email ? 'white' : 'text.primary',
            }}
          >
            <Typography>
                {thisPreview.recipient.email}
            </Typography>

          </Button>
        )
    }

    return (
      <Paper
        elevation={3}
        sx={{
          margin: '2rem auto',
        }}
      >

        <Box sx={{
               padding: 2,
               backgroundColor: 'white',
               borderBottom: '1px solid grey'
             }}
         >

          <Box sx={styles.containerRowB}>
            <Typography
              variant="h6"
              gutterBottom
            >
              Recipients
            </Typography>
            <PersonIcon
               sx={{
                position: 'relative',
                top: '-0.3rem',
                fontSize: '2rem'
               }}
            />
          </Box>
        </Box>

        <Box>
          {emailPreviews.map((thisPreview: EmailPreviewModel) => recipientButton(thisPreview))}
        </Box>

      </Paper>
    )
  }

  const getBody = () => {
    if(currentPreview) return currentPreview.body;
    return ""
  }




  return (

    <Box sx={{display: 'flex'}}>

      <Container
         sx={{
           width: '30vw'
         }}
      >
         {emailPreviews.length > 0 &&
             recipientListElement()
          }
      </Container>


      <Container
         sx={{
           width: '70vw'
         }}
      >

        <Paper
          elevation={3}
          sx={{
            margin: '2rem auto',
            overflow: 'hidden'
          }}
        >

        <Box sx={{
          padding: 2,
          backgroundColor: 'white',
          borderBottom: '1px solid grey'}}
        >

          <Box sx={styles.containerRowB}>
            <Typography
              variant="h6"
              gutterBottom
            >
             {currentPreview?.subject}
            </Typography>

            <MailOutlineIcon sx={{
              position: 'relative',
              top: '-0.3rem',
              fontSize: '2.5rem'}}
            />
          </Box>

          <Typography
            variant="body2"
            color="textSecondary"
          >
            From: {currentPreview?.sender.ReferencedUser_c.Email_c}
          </Typography>

          <Typography
            variant="body2"
            color="textSecondary"
          >
            To: {currentPreview?.recipient.email}
          </Typography>
        </Box>

        <Box sx={{
               padding: 3,
               '& img': {maxWidth: '100%'},
               '& table': {maxWidth: '100%'}
             }}
          dangerouslySetInnerHTML={{__html: getBody()}}
        />

      </Paper>
    </Container>
  </Box>
  )
};
